import { jsonGet, jsonPost, jsonPut, jsonDelete } from "../api";

// Attributes API endpoints for ProductTypes
export const getAttributes = async (marketplaceId, hierarchyCode = null) => {
  const params = `?hierarchyCode=${hierarchyCode}`;
  return await jsonGet(`marketplaces/${marketplaceId}/attributes${params}`);
};

export const getAttribute = async (marketplaceId, attributeId) => {
  return await jsonGet(
    `marketplaces/${marketplaceId}/attributes/${attributeId}`
  );
};

export const createAttribute = async (marketplaceId, attributeData) => {
  return await jsonPost(
    `marketplaces/${marketplaceId}/attributes`,
    attributeData
  );
};

export const updateAttribute = async (
  marketplaceId,
  attributeId,
  attributeData
) => {
  return await jsonPut(
    `marketplaces/${marketplaceId}/attributes/${attributeId}`,
    attributeData
  );
};

export const deleteAttribute = async (marketplaceId, attributeId) => {
  return await jsonDelete(
    `marketplaces/${marketplaceId}/attributes/${attributeId}`
  );
};
